import { CTA } from '@volkswagen-onehub/components-core';
import { Add } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { useOfertaCard } from '../../context/ofertas-card-context';
import { getFinanciacionType, getPagoFinanciado, getPagoUnico } from '../../helpers/ofertas-helper';
import { useTrackingManager } from '../../tracking/use-tracking-manager';

export const OpenLayerCTA = ({ buttonSize }: { buttonSize: 'small' | 'large' }): React.ReactElement => {
	const { setIsLayerVisible, selectedOferta, setSelectedOferta } = useOfertaCard();

	const trackingManager = useTrackingManager();

	const handleOpenLayerOnClick = () => {
		if (setSelectedOferta && selectedOferta) {
			setSelectedOferta(selectedOferta);

			const pagoFinanciado = getPagoFinanciado(selectedOferta.datosEconomicos);
			trackingManager.trackOfertasButtonClick(
				'Open Oferta Layer',
				{ contentId: 'Open Oferta Layer' },
				{
					CarlineId: selectedOferta.carline?.code.toString(),
					CarlineName: selectedOferta.carline?.title,
					ModelId: selectedOferta.configuracion.motorizacion.code?.split('-')[0],
					ModelName: selectedOferta.carline?.salesgroup.model.name,
					ModelYear: selectedOferta.carline?.salesgroup.year.toString(),
					SalesgroupName: selectedOferta.carline?.salesgroup.title,
					PriceRateType: pagoFinanciado ? getFinanciacionType(pagoFinanciado) : undefined,
					PriceRateTotal: pagoFinanciado?.precio ?? undefined,
					PriceRateCurrency: 'EUR',
					PriceTotalTotal: getPagoUnico(selectedOferta?.datosEconomicos)?.precio ?? undefined,
					PriceTotalCurrency: 'EUR',
				},
			);
		}

		setIsLayerVisible(true);
	};

	return (
		<CTA
			tag="button"
			emphasis="primary"
			onClick={handleOpenLayerOnClick}
			ariaL-label="Abrir oferta layer"
			size={buttonSize}
			icon={<Add variant={buttonSize === 'large' ? 'default' : 'small'} aria-hidden />}
		/>
	);
};
